
export function Logger (label?:any, data?: any) {
  console.log(label, data)
  return true
}
